import React from "react";
import Image from "next/image";
import {AspectRatio, Center, HStack, SimpleGrid, Stack, Text} from "@chakra-ui/react";
import Title from "@/components/title";
import {TEXT_VARIANTS} from "@/theme/components/text";
import {CLOUD_MANAGEMENT} from "../cloudApplication.constant";

const CloudManagement = () => {
  return (
    <Stack spacing={8}>
      <Title
        color={"brand.100"}
        highlight={"Management"}
        title={CLOUD_MANAGEMENT.TITLE}
      />
      <SimpleGrid columns={{base: 1, md: 2}} spacing={6}>
        <Center borderColor={"blue.300"} borderWidth={"2px"}>
          <AspectRatio
            position={"relative"}
            ratio={3 / 2}
            width={{base: "300px", md: "550px"}}
          >
            <Image
              alt="Cloud-Application"
              src={"/cloud-application/Cloud-Delivery.webp"}
              fill
              style={{objectFit: "contain", objectPosition: "center"}}
            />
          </AspectRatio>
        </Center>
        <Stack>
          {CLOUD_MANAGEMENT.LIST.map((list, index) => (
            <HStack bgColor={"brand.100"} key={index} p={4} spacing={4}>
              <Center bgColor={"white"} borderRadius={"50%"} w={"2rem"} h={"2rem"} p={4}>
                <Text textAlign={"center"} variant={TEXT_VARIANTS.BODY2}>
                  {index + 1}
                </Text>
              </Center>
              <Text
                color={"white"}
                variant={TEXT_VARIANTS.BODY2}
                _hover={{color: "blue.300"}}
              >
                {list}
              </Text>
            </HStack>
          ))}
        </Stack>
      </SimpleGrid>
    </Stack>
  );
};

export default CloudManagement;
